<template>
    <div>
        <v-row align="center" no-gutters>
            <v-col :class="[{'grow': $vuetify.breakpoint.smAndUp},
                            {'grow px-3': $vuetify.breakpoint.xsOnly}]">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                              label="Suchen"
                              dense light class="white"
                              :solo="$vuetify.breakpoint.smAndUp"
                              :flat="$vuetify.breakpoint.smAndUp"
                              :filled="$vuetify.breakpoint.xsOnly"
                              single-line hide-details clearable>
                </v-text-field>
            </v-col>
            <v-col :class="[{'shrink text-no-wrap ml-3': $vuetify.breakpoint.smAndUp},
                            {'shrink text-no-wrap pr-3': $vuetify.breakpoint.xsOnly}]" >
                <v-checkbox v-model="showCompleted" label="inkl. Erledigte">
                </v-checkbox>
            </v-col>
        </v-row>
        <download-to-excel class="pa-2"
                           :json-list="filteredList"
                           sheet-name="test"
                           :file-time-stamp="null"
                           :config="headersExcel">
        </download-to-excel>
        <v-data-table :headers="headers"
                      :items="doppelstarts"
                      @current-items="getFiltered"
                      :mobile-breakpoint="1"
                      :search="search">
            <template v-slot:item.spiele="{ item }">
                <div class="py-1 text-no-wrap">
                    <div v-for="(spiel, i) in item.spiele" :key="i">
                        <v-btn icon @click="openSpielbericht(spiel)">
                            <v-icon>mdi-file-document-outline</v-icon>
                        </v-btn>
                        <span class="">{{spiel.liga}} / {{spiel.team}}
                            <span v-if="spiel.strafverifiziert">(strafverifiziert)</span>
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:item.status="{ item }">
                <span :class="[{'success--text font-weight-bold': item.status==='erledigt'}]">{{item.status}}</span>
            </template>
        </v-data-table>
        <spiel-bericht-edit-confirm v-if="$route.query.action==='displayErgebnisDoppelstart'"
                                    :set-realtime="true"
                                    :currentData="selectedSpiel"
                                    action="displayErgebnisDoppelstart">
        </spiel-bericht-edit-confirm>
        <!--<pre>{{doppelstartDocs[0]}}</pre>-->
    </div>
</template>

<script>
    import DownloadToExcel from "@/utilities/components/downloads/downloadToExcel";
    import SpielBerichtEditConfirm from "../spielbericht/edit/spielBerichtEditConfirm";
    import FirebaseRead from "@/services/database/firebaseRead";

    export default {
        components: {
            SpielBerichtEditConfirm,
            DownloadToExcel},
        name: "doppel-start-tab",
        props: ['doppelstartDocs'],
        computed: {
            doppelstartsRaw(){
                return this.doppelstartDocs.map(doppelstart => {
                    doppelstart.status = this.getStatus(doppelstart);
                    doppelstart.einsaetzeExcel = this.getEinsaetzeExcel(doppelstart);
                    doppelstart.rundeFull = doppelstart.saison.runde + ' ' + doppelstart.saison.semester;
                    doppelstart.vereinFull = doppelstart.verein.nr + ' / ' + doppelstart.verein.name;
                    doppelstart.spielerFull = doppelstart.spieler.passNr + ' / ' + doppelstart.spieler.name;
                    return doppelstart
                });
            },
            doppelstarts(){
                return this.showCompleted ? this.doppelstartsRaw :
                    this.doppelstartsRaw.filter(doppelstart => doppelstart.status === 'offen');
            }
        },
        data: () => ({
            search: null,
            showCompleted: false,
            selectedSpiel: null,
            filteredList: [],
            headers: [
                { text: 'Runde', value: 'rundeFull' },
                { text: 'Verein', value: 'vereinFull' },
                { text: 'Spieler', value: 'spielerFull' },
                { text: 'Einsätze', value: 'spiele' },
                { text: 'Status', value: 'status' },
            ],
            headersExcel: [
                    { text: 'Runde', value: 'rundeFull' },
                    { text: 'Verein', value: 'vereinFull' },
                    { text: 'Spieler', value: 'spielerFull' },
                    { text: 'Einsätze', value: 'einsaetzeExcel' },
                    { text: 'Status', value: 'status' },
                ]
            }),
        methods: {
            getStatus(doppelstart){
                const nichtStrafverifizierteSpiele = doppelstart.spiele.filter(spiel => !spiel.strafverifiziert);
                return nichtStrafverifizierteSpiele.length > 1 ? 'offen' : 'erledigt';
            },
            getEinsaetzeExcel(doppelstart){
                let einsaetze = [];
                doppelstart.spiele.forEach( (spiel) => {
                    let text = spiel.liga + ' / ' + spiel.team;
                    if ( spiel.strafverifiziert ) { text += ' (strafverifiziert)'}
                    einsaetze.push(text)
                });
                return einsaetze.join(', ')
            },
            getFiltered(vuetifyTableList){
                this.filteredList = vuetifyTableList;
            },
            async openSpielbericht(spiel){
                console.log ("spiel: ", spiel);
                this.selectedSpiel = await FirebaseRead.readSingleDoc('spiele', spiel.spielId);
                console.log ("selectedSpiel", this.selectedSpiel);
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = 'displayErgebnisDoppelstart';
                q.spielId = spiel.spielId;
                this.$router.push({path: p, query: q});
            },
        },
    }
</script>

<style scoped>

</style>